import { useContext, useEffect, useState } from "react";
import RateOptionsAPI from "../API/RateOptionsAPI";
import AssociacionsAPI from "../API/AssociationsAPI";
import { Context } from "..";

const showLogs = false;
const useRateOptions = (loanValue, responsibleId) => {

    const { store } = useContext(Context);
    const [hourCost, setHourCost] = useState(0);
    const [currDiscount, setCurrDiscount] = useState(0);

    const [loan, setLoan] = useState(0);
    const [tasks, setTasks] = useState([]);

    const [rateSumm, setSumm]  = useState(0);
    const [loanSumm, setLoanSumm]  = useState(0);

    useEffect(() => {
        loadHourCost().then(() => showLogs && console.log("[✓] Стоимость часа по займам загружена"));
        loadTasks().then(() => showLogs && console.log("[✓] Задачи тарифных опций загружены"));
    }, []);
    useEffect(() => {
        setLoanSumm(mathLoanSumm());
        if (!tasks || tasks.length == 0) return;
        setSumm(mathSumm());
    }, [tasks, hourCost, loan, loanValue, currDiscount]);

    const loadHourCost = async () => {
        try {
            const association = await AssociacionsAPI.getAll();
            const result = await store.getPositionInfo(responsibleId ? responsibleId : association.data.loan_id);
            if (result.error === true) throw result;

            setCurrDiscount(result.response ? result.response.discount : 0);
            setHourCost(result.response ? result.response.hoursCost : 0);
        } catch (err) {
            showLogs && console.log("[x] Ошибка в расчетах стоимости часа в займах:", err);
            setHourCost(0);
        }
    }
    const loadTasks = async () => {
        try {
            const response = await RateOptionsAPI.getAll();
            if (response.status !== 200) throw response;
            // if (!response.data.options || response.data.options.length === 0) return;

            for (let i = 0; i < response.data.options.length; i++) {
                response.data.options[i]["value"] = 0;
            }
            setLoan(response.data.loan);
            setTasks(response.data.options);
        } catch (err) {
            showLogs && console.log("[x] Ошибка получения параметров первички:", err);
        }
    }

    const mathSumm = () => {
        try {
            let summ = 0;
            for (let i = 0; i < tasks.length; i++) {
                let task = tasks[i];
                summ += task.isMulti ? (task.value * task.cost) : (task.value === 1 ? task.cost : 0);
            }

            return Math.ceil(summ);
        } catch (err) {
            showLogs && console.log("[x] Ошибка вычисления в разделе тарифных опций:", err);
            return 0;
        }
    }
    const mathLoanSumm = () => {
        try {
            let summ = loanValue * loan * (hourCost / 60);
            return Math.ceil(summ);
        } catch (err) {
            showLogs && console.log("[x] Ошибка вычисления займов в разделе тарифных опций:", err);
            return 0;
        }
    }

    return {
        rate_hourCost: hourCost,
        rate_tasks: tasks,
        rate_summ: rateSumm,
        loanSumm: loanSumm,
        setRateValue: (index, value) => {
            let newTasks = [...tasks];
            newTasks[index].value = value;
            setTasks(newTasks);
        },
        rate_changeDiscount: async (newDiscount) => {
            if (newDiscount == undefined) return;
            if (newDiscount == currDiscount) return;
            await loadHourCost();
            setCurrDiscount(newDiscount);
        },
        rate_changeAssociation: async () => {
            await loadHourCost();
        }
    }
}

export default useRateOptions;
